<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vJlZF3/tc-custom/9781507302804.jpg?1737196544102" alt="This image is the cover for the book Traveling Rose"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Traveling Rose
      </h1>
      <p class="bookDescription body article font2">
        <p>Award-winning author-and-illustrator team Brian Wray and Shiloh Penfield are back with a new adventure featuring their beloved children's book character, Rose the stuffed bunny. In Traveling Rose, she is taking her very first big trip to London with her friend Iris and her favorite little boy. Rose is excited about the teas they would have, but soon becomes distracted by her worries. Did she pack her favorite sweater in case the weather is cold? Did she remember to turn off the lamp by her bedside? Her thoughts feel so big that Rose begins to cry and no longer wants to go. Can Rose find a way to let her worries at home and have fun on her trip?  The story offers a great way for parents and teachers to talk to children about what happens when impulsive and obsessive thoughts get in the way of enjoying life's big moments as well as everyday life, and what to do about it. These types of “first times” can be stressful for anyone but, for someone with intrusive thoughts, can be filled with obstacles. Intrusive worries are there at every turn, pointing out all of the things that could go wrong or that are “dangerous.” It takes work to see through the fears and picture the possibilities, especially for our beloved Rose Bunny.  Children will identify with Rose, and by allowing children to see themselves in a story, it shows them that they are not alone in their experience. Ideal for social and emotional learning, Traveling Rose teaches children to express emotion, which is one of the key ingredients to healthful development. Rose continues to be a starting point to having larger conversations that will create a lasting impact. Don’t miss her in her first picture book, Unraveling Rose.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Wray, Shiloh Penfield
      </h2>
      
      <p class="authorDescription body article">Brian lives in Brooklyn with his family and their infinite support. Brian is also the author of Fen's Drop of Gray and Maia and the Very Tall Wall. His first two books, Max’s Box and Unraveling Rose, were awarded the 2019 and 2017 Foreword INDIES Gold Winner for Picture Books, Early Reader. Visit him at www.authorbrianwray.com or follow him on Instagram @stanberybooks.  Shiloh’s previous work includes Boy Zero for Caliber Comics, a guest artist spot on Red Knight, published by Dead West Comics, independent projects, and all four of Brian Wray's books, including the award-winning Unraveling Rose. She lives in Brooklyn, New York, with her calico cat, Maki, who maintains quality control and ensures all pages are delivered on time. Follow her on Instagram @shilohpenfield.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Schiffer Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54de4310